var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1613 17.04C16.0679 17.0267 15.9479 17.0267 15.8413 17.04C13.4946 16.96 11.6279 15.04 11.6279 12.68C11.6279 10.2666 13.5746 8.30664 16.0013 8.30664C18.4146 8.30664 20.3746 10.2666 20.3746 12.68C20.3613 15.04 18.5079 16.96 16.1613 17.04Z",
    stroke: "white",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.988 25.8401C22.6147 28.0134 19.468 29.3334 16.0014 29.3334C12.5346 29.3334 9.38798 28.0134 7.01465 25.8401C7.14798 24.5867 7.94798 23.3601 9.37465 22.4001C13.028 19.9734 19.0014 19.9734 22.628 22.4001C24.0547 23.3601 24.8547 24.5867 24.988 25.8401Z",
    stroke: "white",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 29.3327C23.3641 29.3327 29.3337 23.3631 29.3337 15.9993C29.3337 8.63555 23.3641 2.66602 16.0003 2.66602C8.63653 2.66602 2.66699 8.63555 2.66699 15.9993C2.66699 23.3631 8.63653 29.3327 16.0003 29.3327Z",
    stroke: "white",
    strokeWidth: 1.06667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.bc80e3fd7f8b87f31798646d946ea4e1.svg";
export { ForwardRef as ReactComponent };